// Console d'administration : logique pure de la file de validation des
// e-mails (onglets, libellés, sélection), testée sans navigateur.
import type { AppSummary, EmailStatus, EmailSummary } from '@feedbaacks/sdk'
import type { DashKey } from '../i18n'

/** Onglets de l'écran. « sending » est transitoire : pas d'onglet. */
export const OUTBOX_TABS = ['pending', 'sent', 'rejected', 'failed'] as const satisfies readonly EmailStatus[]
export type OutboxTab = (typeof OUTBOX_TABS)[number]

type Tr = (key: DashKey, params?: Record<string, string | number>) => string

const SOURCE_KEYS: Record<string, DashKey> = { digest: 'outbox_source_digest', notification: 'outbox_source_notification' }

/** Source en clair ; une source inconnue s'affiche telle quelle. */
export function sourceLabel(source: string, tr: Tr): string {
  const key = SOURCE_KEYS[source]
  return key ? tr(key) : source
}

/** Nom lisible de l'app, sinon sa clé. */
export function appLabel(apps: AppSummary[], key: string | null): string {
  return key ? (apps.find((a) => a.key === key)?.name ?? key) : ''
}

/** Ce que l'onglet ajoute à la ligne : envoi et valideur, refus et motif,
 *  erreur et essais. Un refus sans valideur est automatique (péremption). */
export function statusNote(e: EmailSummary, tr: Tr, date: (iso: string) => string): string {
  const by = e.reviewed_by?.name
  const parts: Array<string | false | null | undefined> = []
  switch (e.status) {
    case 'sent':
      parts.push(e.sent_at && tr('outbox_sent_at', { date: date(e.sent_at) }), by && tr('outbox_validated_by', { name: by }))
      break
    case 'rejected':
      parts.push(by ? tr('outbox_rejected_by', { name: by }) : !e.reviewed_by && tr('outbox_rejected_auto'), e.reject_reason && tr('outbox_reason', { reason: e.reject_reason }))
      break
    case 'failed':
      parts.push(e.error_message && tr('outbox_error', { error: e.error_message }), tr('outbox_attempts', { n: e.attempts }))
      break
  }
  return parts.filter(Boolean).join(' · ')
}

export function toggle(selected: string[], id: string): string[] {
  return selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]
}

/** Tout cocher, ou tout décocher si tout l'est déjà. */
export function toggleAll(selected: string[], ids: string[]): string[] {
  return ids.length > 0 && ids.every((id) => selected.includes(id)) ? [] : ids
}

/** Ton de la notification d'un lot : tout passé, rien passé, ou partiel. */
export function bulkTone(done: number, failed: number): 'success' | 'info' | 'error' {
  return failed === 0 ? 'success' : done === 0 ? 'error' : 'info'
}
